import { render, staticRenderFns } from "./paginationComponent.vue?vue&type=template&id=7d5ff9d7&scoped=true"
import script from "./paginationComponent.vue?vue&type=script&lang=js"
export * from "./paginationComponent.vue?vue&type=script&lang=js"
import style0 from "./paginationComponent.vue?vue&type=style&index=0&id=7d5ff9d7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ff9d7",
  null
  
)

export default component.exports